/**
 * Session: ~30 days — استدعاء sessionLogin لتعيين cookie وتجديد التوكن دورياً
 * الهدف: تقليل الحاجة لتسجيل الدخول مرة أخرى في لوحة التحكم
 *
 * مهم: توكن Firebase ID ينتهي بعد ساعة. تجديده كل ~50 دقيقة يمنع انتهاءه وبالتالي يقلل احتمال
 * أن تقوم الـ SDK بتسجيل الخروج تلقائياً (auth/user-token-expired).
 */
import { app } from '../firebase'

const PROJECT_ID = app.options.projectId
const REGION = 'us-central1'
const SESSION_LOGIN_URL = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net/sessionLogin`
// تجديد توكن Firebase كل 50 دقيقة (التوكن صالح ساعة — نبقى تحته لتفادي انتهاء الجلسة)
const REFRESH_INTERVAL_MS = 50 * 60 * 1000
// أول تجديد بعد دقيقتين من الدخول (لتقليل الضغط وضمان استقرار الجلسة)
const FIRST_REFRESH_DELAY_MS = 2 * 60 * 1000

let refreshTimerId: ReturnType<typeof setInterval> | null = null
let firstRefreshTimeoutId: ReturnType<typeof setTimeout> | null = null

export async function callSessionLogin(idToken: string): Promise<boolean> {
  try {
    const res = await fetch(SESSION_LOGIN_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ idToken }),
    })
    if (!res.ok) {
      console.warn('[Session] sessionLogin failed:', res.status)
      return false
    }
    return true
  } catch (e) {
    console.warn('[Session] sessionLogin error:', e)
    return false
  }
}

export function startSessionRefresh(getIdToken: () => Promise<string | undefined>): void {
  stopSessionRefresh()
  const refresh = async () => {
    try {
      const token = await getIdToken()
      if (token) await callSessionLogin(token)
    } catch (e) {
      // عدم ترك الـ promise مرفوضة يمنع تأثير فشل التجديد على بقية التطبيق
      console.warn('[Session] token refresh error (will retry next interval):', e)
    }
  }
  // أول تجديد بعد دقيقتين ثم كل 50 دقيقة
  firstRefreshTimeoutId = setTimeout(() => {
    firstRefreshTimeoutId = null
    refresh()
    refreshTimerId = setInterval(refresh, REFRESH_INTERVAL_MS)
  }, FIRST_REFRESH_DELAY_MS)
}

export function stopSessionRefresh(): void {
  if (firstRefreshTimeoutId) {
    clearTimeout(firstRefreshTimeoutId)
    firstRefreshTimeoutId = null
  }
  if (refreshTimerId) {
    clearInterval(refreshTimerId)
    refreshTimerId = null
  }
}
